<template>
    <div>
        <validation-observer ref="createNomineeDirectorValidation">
            <validation-provider
                v-slot="{ errors }"
                name="nominee director name"
                rules="required"
            >
                <b-form-group label="Nominee director name">
                    <b-form-input
                        id="name"
                        v-model="nomineeDirector.name"
                        :state="errors.length > 0 ? false : null"
                        data-test="nominee-director-name"
                        readonly
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
            </validation-provider>

            <validation-provider
                v-slot="{ errors }"
                name="nominator type"
                rules="required"
                mode="lazy"
                class="end-align-indicator-long-select"
            >
                <b-form-group
                    label="Nominator type"
                    :state="errors.length > 0 ? false : null"
                >
                    <v-select
                        ref="nominatorType"
                        v-model="nomineeDirector.nominatorType"
                        class="custom-select-icon text-capitalize"
                        :clearable="false"
                        placeholder="Select nominator type"
                        label="text"
                        :options="nominatorTypeOptions"
                        @input="onNominatorTypeChange"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="appointment date"
              rules="required"
            >
                <b-form-group label="Date on which the director became the nominee" :state="errors.length > 0 ? false : null">
                    <flat-pickr
                        v-model="nomineeDirector.appointmentDate"
                        placeholder="Pick a date"
                        class="form-control"
                        :config="datePickerConfig"
                        data-test="date-picker-appointment-date"
                    />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="cessation date"
            >
                <b-form-group label="Date on which the director ceased to be the nominee" :state="errors.length > 0 ? false : null">
                    <flat-pickr
                        v-model="nomineeDirector.cessationDate"
                        placeholder="Pick a date"
                        class="form-control"
                        :config="datePickerConfig"
                        data-test="date-picker-cessation-date"
                    />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
            </validation-provider>

            <validation-provider
                v-slot="{ errors }"
                :name="dynamicNameLabel.toLowerCase()"
                rules="required"
                mode="lazy"
                class="end-align-indicator-long-select"
            >
                <b-form-group
                    :label="dynamicNameLabel"
                    :state="errors.length > 0 ? false : null"
                >
                    <v-select
                        id="name"
                        ref="nominator"
                        v-model="nomineeDirector.nominator"
                        :placeholder="dynamicNamePlaceholder"
                        :state="errors.length > 0 ? false : null"
                        data-test="nominator-name"
                        class="custom-select-icon text-capitalize"
                        :clearable="false"
                        label="name"
                        :options="nominators"
                        @input="onNominatorChange"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
            </validation-provider>

            <!-- < INDIVIDUAL NOMINATOR > -->
            <div v-if="isNominatorTypeIndividual">
                <validation-provider
                    v-slot="{ errors }"
                    name="individual nominator aliases"
                >
                    <b-form-group label="Individual nominator aliases, if any">
                        <b-form-input
                            id="name"
                            v-model="nomineeDirector.nominatorAlias"
                            placeholder="individual nominator aliases"
                            :state="errors.length > 0 ? false : null"
                            data-test="nominatorAlias"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>
            </div>
            <!-- </ INDIVIDUAL NOMINATOR > -->

            <!-- < CORPORATE NOMINATOR > -->
            <div v-if="! isNominatorTypeIndividual">
                <validation-provider
v-slot="{ errors }"
                    name="corporate nominator UEN"
                    rules="required"
                >
                    <b-form-group label="Corporate nominator UEN issued by the registrar (ACRA)">
                        <b-form-input
                            id="name"
                            v-model="nomineeDirector.nominatorUen"
                            placeholder="Enter corporate nominator UEN"
                            :state="errors.length > 0 ? false : null"
                            data-test="nominator-uen"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    v-slot="{ errors }"
                    name="corporate nominator legal form"
                    rules="required"
                    class="end-align-indicator-long-select"
                >
                    <b-form-group
                        label="Corporate nominator legal form"
                        :state="errors.length > 0 ? false : null"
                    >
                        <v-select
                            ref="legalForm"
                            v-model="nomineeDirector.nominatorLegalForm"
                            placeholder="Select corporate nominator legal form"
                            class="custom-select-icon text-capitalize"
                            :clearable="false"
                            label="text"
                            :options="legalForms"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>

                <validation-provider
v-slot="{ errors }"
                    name="corporate nominator jurisdiction"
                    rules="required"
                    class="end-align-indicator-long-select"
                >
                    <b-form-group label="Corporate nominator jurisdiction" :state="errors.length > 0 ? false : null">
                            <v-select
                            ref ="jurisdiction"
                            v-model="nomineeDirector.nominatorJurisdiction"
                            :clearable="false"
                            :options="jurisdictions"
                            label="name"
                            value="id"
                            class="custom-select-icon text-capitalize"
                            placeholder="Select corporate nominator jurisdiction"
                            @input="onNominatorJurisdictionChange"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>

                <validation-provider
v-slot="{ errors }"
                    name="corporate nominator statue"
                    rules="required"
                    mode="lazy"
                    class="end-align-indicator-long-select"
                >
                    <b-form-group label="Corporate nominator statue under which the corporate is formed" :state="errors.length > 0 ? false : null">
                        <v-select
                            ref="statue"
                            v-model="nomineeDirector.nominatorStatue"
                            placeholder="Select corporate nominator statue"
                            class="custom-select-icon text-capitalize"
                            :clearable="false"
                            label="name"
                            value="id"
                            :options="statues"
                            :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>

                <validation-provider
v-slot="{ errors }"
                    name="registrar"
                    rules="required"
                    mode="lazy"
                    class="end-align-indicator-long-select"
                >
                    <b-form-group :state="errors.length > 0 ? false : null" label="Name of corporate nominator's register of the jurisdiction where the legal entity is formed or incorporated">
                        <v-select
                            ref="nominatorRegistrar"
                            v-model="nomineeDirector.nominatorRegistrar"
                            class="custom-select-icon text-capitalize"
                            :clearable="false"
                            label="name"
                            value="id"
                            :options="registrars"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Select corporate registrar"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>
            </div>
            <!-- < /CORPORATE NOMINATOR > -->
           
            <validation-provider
                v-slot="{ errors }"
                name="remark"
            >
                <b-form-group label="Remarks">
                    <b-form-input
                        id="remark"
                        v-model="nomineeDirector.remark"
                        placeholder="Enter nominee director remark"
                        :state="errors.length > 0 ? false : null"
                        data-test="remark"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
            </validation-provider>
        </validation-observer>

        <div class="switch-check mt-2 mb-2">
            <b-form-checkbox 
                v-model="nomineeDirector.generatePOA" 
                :checked="nomineeDirector.generatePOA" 
                switch
                size="md"
            > 
                Generate POA Documents 
            </b-form-checkbox>
        </div>

        <b-button v-if="existNominators" block class="mt-2" variant="primary" data-test="create-or-edit-nominee-director" @click="createOrUpdate"
            >{{ status === "create" ? "Add" : "Update" }}
            <img
                v-if="status === 'create'"
                :src="'/illustrations/add-circle.svg'"
                class="float-right"
                alt="add-logo"
            />
            <img
                v-if="status === 'edit'"
                :src="'/illustrations/edit.svg'"
                class="float-right"
                alt="edit-logo"
            />
        </b-button>

        <b-button            
            block
            class="mb-3"
            variant="outline-primary" 
            data-test="cancelCreate"           
            @click="$emit('cancel')"
            >Cancel
            <img
                :src="'/illustrations/cancel-circle.svg'"
                class="float-right"
                alt="cancel-logo"
            />
        </b-button>
    </div>
</template>

<script>
import {
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import { debounce } from 'debounce';
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { formatDate } from '@core/utils/filter';
// import Nationality from "@/models/Nationality";
import { NOMINEE_DIRECTOR, SHAREHOLDER } from "@/constants/config";
import Nominator from '@/models/Nominator';
import User from '@/models/User';

export default {
    components: {
        BFormGroup,
        BFormInput,
        BButton,
        BFormCheckbox,
        ValidationObserver,
        ValidationProvider,
        flatPickr,
        vSelect,
    },

    props: {
        dataStatus: {
            required: false,
            default: "create",
            type: String,
        },

        dataNomineeDirector: {
            required: true,
            type: Object,
        },

        dataShareholders: {
            required: true,
            type: Array,
        },
    },

    data() {
        return {
            required,
            email,
            status: this.dataStatus,

            nomineeDirector: {
                // eslint-disable-next-line no-underscore-dangle
                _id: this.dataNomineeDirector._id,
                id: this.dataNomineeDirector.id,
                is_enston_director: this.dataNomineeDirector.is_enston_director,
                is_nominee_director: 1,
                name: this.dataNomineeDirector.name,
                appointmentDate: formatDate(this.dataNomineeDirector.appointmentDate),
                cessationDate: formatDate(this.dataNomineeDirector.cessationDate),
                remark: this.dataNomineeDirector.remark,

                nominatorId: this.dataNomineeDirector.nominatorId,
                nominatorType: this.dataNomineeDirector.nominatorType,
                nominator: this.dataNomineeDirector.nominator,
                nominatorAlias: this.dataNomineeDirector.nominatorAlias,

                nominatorUen: this.dataNomineeDirector.nominatorUen,
                nominatorLegalForm: this.dataNomineeDirector.nominatorLegalForm,
                nominatorJurisdiction: this.dataNomineeDirector.nominatorJurisdiction,
                nominatorStatue: this.dataNomineeDirector.nominatorStatue,
                nominatorRegistrar: this.dataNomineeDirector.nominatorRegistrar,

                generatePOA: this.dataNomineeDirector.generatePOA,
            },

            datePickerConfig: {
                altFormat: "j M Y",
                dateFormat: "j M Y",
                disableMobile: "true"
            },

            // nationality_options: [],
            nominatorTypeOptions: [
                {
                    text: NOMINEE_DIRECTOR.NOMINATOR.TYPE.INDIVIDUAL,
                    value: NOMINEE_DIRECTOR.NOMINATOR.TYPE.INDIVIDUAL,
                },
                {
                    text: NOMINEE_DIRECTOR.NOMINATOR.TYPE.CORPORATE,
                    value: NOMINEE_DIRECTOR.NOMINATOR.TYPE.CORPORATE,
                },
            ],

            statues: [],
            dataStatues: [],
            registrars: [],
            dataRegistrars: [],
            legalForms: [],
            nominators: [],
            jurisdictions: [],
        };
    },

    computed: {
        existNominators()
        {
            return this.nominators.filter(shareholder => !! shareholder).length >= 1;
        },
        
        isNominatorTypeIndividual() {
            // if there is no type yet, act like it's Individual
            if (! this.nomineeDirector.nominatorType) return true;

            return (
                this.nomineeDirector.nominatorType &&
                this.nomineeDirector.nominatorType.text === NOMINEE_DIRECTOR.NOMINATOR.TYPE.INDIVIDUAL
            );
        },

        dynamicIdLabel() {
            if (
                this.nomineeDirector.nominatorType &&
                this.nomineeDirector.nominatorType.text === NOMINEE_DIRECTOR.NOMINATOR.TYPE.CORPORATE
            )
                return "Corporate nominator id on the corporate entity register of the jurisdiction where the corporate controller is formed or incorporated";

            return "Individual nominator ID";
        },

        dynamicIdPlaceholder() {
            if (
                this.nomineeDirector.nominatorType &&
                this.nomineeDirector.nominatorType.text === NOMINEE_DIRECTOR.NOMINATOR.TYPE.CORPORATE
            )
                return "Enter corporate nominator id";

            return "Enter individual nominator id";
        },

        dynamicNameLabel() {
            if (
                this.nomineeDirector.nominatorType &&
                this.nomineeDirector.nominatorType.text === NOMINEE_DIRECTOR.NOMINATOR.TYPE.CORPORATE
            )
                return "Corporate nominator name";

            return "Individual nominator name";
        },

        dynamicNamePlaceholder() {
            if (
                this.nomineeDirector.nominatorType &&
                this.nomineeDirector.nominatorType.text === NOMINEE_DIRECTOR.NOMINATOR.TYPE.CORPORATE
            )
                return "Select corporate nominator";

            return "Select individual nominator";
        }
    },

    async created() {
        this.reInitializeNominators(this.nomineeDirector.nominatorType ? this.nomineeDirector.nominatorType.text : SHAREHOLDER.TYPE.INDIVIDUAL);

        const payload = await Nominator.getCorporateData();
        
        this.jurisdictions = payload.jurisdiction;
        this.statues = payload.statue;
        this.dataStatues = this.statues;
        this.legalForms = payload.legal_form;
        this.registrars = payload.registrar;
        this.dataRegistrars = this.registrars;

        // start with individual by default
        if (! this.nomineeDirector.nominatorType)
            this.nomineeDirector.nominatorType = {
                text: NOMINEE_DIRECTOR.NOMINATOR.TYPE.INDIVIDUAL,
                value: NOMINEE_DIRECTOR.NOMINATOR.TYPE.INDIVIDUAL
            };
    },

    methods: {
        reInitializeNominators(type)
        {
            this.nominators = this.dataShareholders.filter(shareholder => shareholder.shareholderType.text === type).map(shareholder => ({
                referenceId: shareholder.referenceId,
                userId: shareholder.userId,
                name: shareholder.name,
                email: shareholder.email,
                nric: shareholder.nric
            }));
        },

        async onNominatorTypeChange(payload)
        {
            this.reInitializeNominators(payload.value);
            this.nomineeDirector.nominator = '';
            this.nomineeDirector.nominatorUen = null;
        },

        onNominatorJurisdictionChange(payload)
        {
            this.statues = this.dataStatues.filter(statue => statue.jurisdiction_id === payload.id);
            this.registrars = this.dataRegistrars.filter(registrar => registrar.jurisdiction_id === payload.id);
            this.nomineeDirector.nominatorStatue = '';
            this.nomineeDirector.nominatorRegistrar = '';
        },

        onNominatorChange(nominator) {
            this.requestAutoFillNominatorFormData(nominator.nric);
        },

        // eslint-disable-next-line func-names
        requestAutoFillNominatorFormData: debounce(async function(id) {
            const type = this.nomineeDirector.nominatorType?.text;

            if(type && id) {
                const user = await User.getByNRIC(id, type);

                if(user) this.fillNominatorData(user);
            }
        }, 500),

        fillNominatorData(nominator) {
            if(this.isNominatorTypeIndividual) 
                this.nomineeDirector.nominatorAlias = nominator?.individual_shareholder?.alias;

            if(! this.isNominatorTypeIndividual) {
                this.nomineeDirector.nominatorUen = nominator?.user_info?.uen;
                this.nomineeDirector.nominatorStatue = nominator?.shareholder?.statue;
                this.nomineeDirector.nominatorRegistrar = nominator?.shareholder?.registrar;
                this.nomineeDirector.nominatorJurisdiction = nominator?.shareholder?.jurisdiction;
                this.nomineeDirector.nominatorLegalForm = nominator?.shareholder?.legal_form;
            }
        },

        createOrUpdate() {
            this
                .$refs
                .createNomineeDirectorValidation
                .validate()
                .then(async success => {
                    if (success) {
                        this.$emit("createOrEdit", this.nomineeDirector);
                        this.$emit("cancel");
                    }
                });
        },
    },
};
</script>
